import { Icon } from '@chakra-ui/react';

export const CaretUpIcon = (props: any) => (
  <Icon aria-label="caret up icon" viewBox="3 3 18 18" {...props}>
    <path
      d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
      transform="rotate(180,12,12)"
      fill="currentColor"
    />
  </Icon>
);
